import request from './request.js'
// import store from '../store'
import Qs from 'qs';
export function regesterUser(data) {
	return request({
		url: "/tencent/add",
		method: 'post',
		data
	})
}

// 获取所属部门
export function getDepartments(data){
	return request({
		url:"/tencent/depart",
		method:"post",
		data
	})
}
// 根据是否本公司员工获取可预约权限
export function getAuth(params){
	return request({
		url:"/tencent/getAuthorityByType",
		method:"get",
		params
	})
}
export  function getTokens(params){
	return 	request({
		url:'/getJwtToken',
		method:'get',
		params
	})
}

export  function getJsApiSdkParams(params){
	return 	request({
		url:'/getJsApi',
		method:'get',
		params
	})
}

// 获取房间信息
export function getRoomsList(params){
	return request({
		url:'/room/getRoomList',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||''
		},
		params
	})
}
// 预约房间

export function addRoom(data){
	return request({
		url:'/appointment/add',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||''
		},
		data
	})
}
// 预约历史

export function roomHistory(params){
	return request({
		url:'/appointment/apptHistoryPageList',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||''
		},
		params
	})
}
// 取消预约
export function cancelRoom(data){
	return request({
		url:'/appointment/cancel',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||''
			
		},
		data
	})
}
// 图片上传
 
export function uploadImg(data){
	return request({
		url:'/tencent/uploadbase64photo',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
			// "Content-Type":'multipart/form-data'
		},
		data
	})
}
export function queryPersonalInfo(params){
	return request({
		url:'/tencent/query',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
			// "Content-Type":'multipart/form-data'
		},
		params
	})
}
export function saveUserInfo(data){
	return request({
		url:'/tencent/update',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
			// "Content-Type":'multipart/form-data'
		},
		data
	})
}
 export function getCodes(params){
 	return request({
 		url:'/getCode',
 		method:'get',
 		headers:{
 			
 			// "Content-Type":'multipart/form-data'
 		},
 		params
 	})
 }
 
 // 退房 
 export function roomCheckout(data){
 	return request({
 		url:'/appointment/checkOut',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 			// "Content-Type":'multipart/form-data'
 		},
 		data
 	})
 }
 // 上传图片
 export function upLoadPicture(data){
 	return request({
 		url:'/tencent/uploadbase64photo',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 			// "Content-Type":'multipart/form-data'
 		},
 		data
 	})
 }
 
 export function submitComments(data){
 	return request({
 		url:'/appointment/addcomment',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 			// "Content-Type":'multipart/form-data'
 		},
 		data
 	})
 }

export function submitRepaires(data) {
    return request({
        url: '/appointment/addcallrepair',
        method: 'post',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        data
    })
}


export function getMeetingList(params) {
    return request({
        url: '/tb-conference-room/getConferenceRoomList',
        method: 'get',
        headers: {
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

export function getCurrentWeekMeeting(params) {
    return request({
        url: "/tb-appointment-audit/queryConferenceAudit",
        method: 'get',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

// 添加会议预约

export function addAudit(data) {
    return request({
        url: '/tb-appointment-audit/add',
        method: 'post',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        data
    })
}

export function getAuditHistoryList(params) {
    return request({
        url: '/tb-appointment-audit/queryConferAuditPageHistoryList',
        method: 'get',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}


// 会议审核list
export function getAuditLists(params) {
    return request({
        url: "tb-appointment-audit/queryUnCheckList",
        method: 'get',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}


// 会议室历史审核记录
export function getHistoryAuditingLists(params) {
    return request({
        url: '/tb-appointment-audit/queryCheckHistoryList',
        method: "get",
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

// 会议预约审核
export function preAudting(params) {
    return request({
        url: '/tb-appointment-audit/check',
        method: "get",
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}



// 路线list
export function getRoutersLists(params) {
    return request({
        url: '/tb-vehicle-shift/shiftList',
        method: "get",
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

// 路线详情
export function getBusRouterStations(params) {
    return request({
        url: '/tb-bus-router/queryStations',
        method: "get",       
        params
    })
}

// 添加预约坐车
export function addCarsPreOrder(data) {
    return request({
        url: '/tb-bus-apppoint/add?shiftId=' + data.id+"&stationId="+data.stationId,
        method: 'post',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type": 'multipart/form-data'
        },
        // data
    })
}

//当前路线对应站点的预约人数
export function stationApptCount(params){
	return request({
        url: '/tb-bus-apppoint/apptCount',
        method: "get",
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}


//历史坐车预约
export function historyCarsLists(params) {
    return request({
        url: '/tb-bus-apppoint/apptHistory',
        method: "get",
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

//取消坐车预约
export function cancleRouter(data) {
    return request({
        url: '/tb-bus-apppoint/cancel?apppointId=' + data.id,
        method: 'post',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type": 'multipart/form-data'
        },
        // data
    })
}

// 根据id查询会议信息
export function queryMeetingInfos(params) {
    return request({
        url: '/tb-appointment-audit/queryAuditByAuditId',
        method: "get",
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

export function queryComments(params) {
    return request({
        url: '/appointment/querycomment',
        method: 'get',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

export function queryRepaire(params) {
    return request({
        url: "/appointment/querycallrepair",
        method: 'get',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}

// 取消会议室预约

export function cancleMeeting(params) {
    return request({
        url: "/tb-appointment-audit/cancel",
        method: 'get',
        headers: {
            token: localStorage.getItem('token') || '',
            // "Content-Type":'multipart/form-data'
        },
        params
    })
}
 
 // 访客添加预约
 export function addVisitor(data){
 	return request({
 		url:'/visitor-apppoint/add',
 		method:'post',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }

 //判断访客是否在黑名单
  export function visitorBlacklist(data){
 	return request({
 		url:'/visitor-apppoint/judgeblacklist',
 		method:'post',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }

 // 访客预约历史
 export function apptHistory(params){
 	return request({
 		url:'/visitor-apppoint/apptHistory',
 		method:'get',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 访客取消预约
 export function cancel(data){
 	return request({
 		url:'/visitor-apppoint/cancel',
 		method:'post',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
 // 微信用户注册校验，没有注册返回500
 export function registerCheck(data){
 	return request({
 		url:'/visitor-apppoint/registerCheck',
 		method:'post',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }

 //校验当前用户是否注册，没有注册返回201
 export function userCheck(data){
	return request({
		url:'/visitor-apppoint/userCheck',
		method:'post',
		headers:{
		   token:localStorage.getItem('token')||'',
		},
		data
	})
}

 // 访客门岗预约查询
 export function guardApptQuery(params){
 	return request({
 		url:'/visitor-apppoint/guardApptQuery',
 		method:'get',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 访客审核
 export function checked(data){
 	return request({
 		url:'/visitor-checker/checked',
 		method:'post',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
  // 访客历史审核列表分页
 export function checkedHistory(params){
 	return request({
 		url:'/visitor-checker/checkedHistory',
 		method:'get',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
// 访客编辑审核
 export function checkerEdit(data){
 	return request({
 		url:'/visitor-checker/checkerEdit',
 		method:'post',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
// 访客未审核列表分页
 export function noCheckedList(params){
 	return request({
 		url:'/visitor-checker/noCheckedList',
 		method:'get',
 		headers:{
			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 访客添加审核人
 export function addChecker(data){
 	return request({
 		url:'/visitor-checker/addChecker',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
 // 访客删除审核人
 export function delChecker(data){
 	return request({
 		url:'/visitor-checker/delChecker',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }

 // 车辆运输添加预约
 export function addTransport(data){
 	return request({
 		url:'/tb-transport-report/add',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
 // 车辆运输预约历史
 export function transportHistory(params){
 	return request({
 		url:'/tb-transport-report/apptHistory',
 		method:'get',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 车辆运输取消预约
 export function transportCancel(data){
 	return request({
 		url:'/tb-transport-report/cancel',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }

 // 车辆运输根据关键字获取分类下拉框内容(C02 运输车队、C03 运输物资、C04 卸货地点、C05 运输路线、C06 紫金山入口
 export function getSysCategory(params){
 	return request({
 		url:'/tb-transport-report/getSysCategory',
 		method:'get',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 车辆运输门岗预约查询
 export function transportQuery(params){
 	return request({
 		url:'/tb-transport-report/guardApptQuery',
 		method:'get',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 车辆运输审核
 export function transportChecked(data){
 	return request({
 		url:'/tb-transport-checker/checked',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
 // 车辆运输历史审核列表分页
 export function transportCheckedHistory(params){
 	return request({
 		url:'/tb-transport-checker/checkedHistory',
 		method:'get',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 车辆运输被访问者编辑审核
 export function transportCheckerEdit(data){
 	return request({
 		url:'/tb-transport-checker/checkerEdit',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
 // 车辆运输未审核列表分页
 export function transportNoCheckedList(params){
 	return request({
 		url:'/tb-transport-checker/noCheckedList',
 		method:'get',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		params
 	})
 }
 // 车辆运输添加审核人
 export function transportAddChecker(data){
 	return request({
 		url:'/tb-transport-checker/addChecker',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }
 // 车辆运输删除审核人
 export function transportDelChecker(data){
 	return request({
 		url:'/tb-transport-checker/delChecker',
 		method:'post',
 		headers:{
 			token:localStorage.getItem('token')||'',
 		},
 		data
 	})
 }

  // 车辆确认离矿
  export function confirmLeave(params){
	return request({
		url:'/tb-transport-report/confirmLeave',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 访客确认离矿
export function apppointConfirmLeave(data){
	return request({
		url:'/visitor-apppoint/confirmLeave',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}


// 物资出矿添加
export function tbGoodsReportAdd(data){
	return request({
		url:'/tb-goods-report/add',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 物资出矿申请历史
export function tbGoodsReportHistory(params){
	return request({
		url:'/tb-goods-report/apptHistory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 物资出矿取消申请
export function tbGoodsReportCancel(data){
	return request({
		url:'/tb-goods-report/cancel',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 物资出矿获取分类数据
export function tbGoodsReportGetSysCategory(params){
	return request({
		url:'/tb-goods-report/getSysCategory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 物资出矿门岗查询
export function tbGoodsReportGuardApptQuery(params){
	return request({
		url:'/tb-goods-report/guardApptQuery',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 物资出矿添加审核人
export function tbGoodsAddChecker(data){
	return request({
		url:'tb-goods-checker/addChecker',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 物资出矿审核
export function tbGoodsChecked(data){
	return request({
		url:'/tb-goods-checker/checked',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 物资出矿已经审核列表
export function tbGoodsCheckedHistory(params){
	return request({
		url:'/tb-goods-checker/checkedHistory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 物资出矿审核者编辑审核
export function tbGoodsCheckerEdit(data){
	return request({
		url:'/tb-goods-checker/checkerEdit',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}

// 物资出矿删除审核人
export function tbGoodsDelChecker(data){
	return request({
		url:'/tb-goods-checker/delChecker',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 物资出矿未审核列表
export function tbGoodsNoCheckedList(params){
	return request({
		url:'/tb-goods-checker/noCheckedList',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//#region 审核模块
//-------------------------------------------------------

//#region  气瓶模块
//查询气瓶入库审核数据
export function incommingAuditHistory(params){
	return request({
		url:'/tb-incoming-applyfor/queryAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//气瓶入库审核
export function incommingAudit(params){
	return request({
		url:'/tb-incoming-applyfor/incomingAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//气瓶入库记录详情列表
export function queryIncomingDetail(params){
	return request({
		url:'/tb-incoming-applyfor/queryIncomingDetail',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//查询气瓶领用审核数据
export function borrowAuditHistory(params){
	return request({
		url:'/tb-borrow-applyfor/queryAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//气瓶领用历史列表
export function queryBorrowHistory(params){
	return request({
		url:'/tb-borrow-applyfor/queryBorrowHistory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//气瓶领用历史列表详情
export function queryBorrowDetail(params){
	return request({
		url:'/tb-borrow-applyfor/queryBorrowDetail',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//气瓶领用审核
export function borrowAudit(params){
	return request({
		url:'/tb-borrow-applyfor/borrowAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//气瓶领用根据条码查询气瓶信息
export function queryBorrowBottle(params){
	return request({
		url:'tb-borrow-applyfor/queryBottle',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//根据气瓶二维码查询气瓶领用信息
export function queryBorrowBottleByQrcode(params){
	return request({
		url:'tb-borrow-applyfor/queryBottleByQrcode',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//查询气瓶归还审核数据
export function returnAuditHistory(params){
	return request({
		url:'/tb-return-applyfor/queryAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//气瓶领用审核
export function returnAudit(params){
	return request({
		url:'/tb-return-applyfor/returnAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//#endregion 审核模块

//查询领用和归还的部门信息
export function querySysDeptInfo(){
	return request({
		url:'/tb-bottle-info/querySysDepts',
		method:'get'
	})
}

// 气瓶充装介质
export function getBottleTypes(params){
	return request({
		url:'/tb-bottle-info/queryGasType',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 审核人员
// /mjapi/
export function getAdmins(params){
	return request({
		url:'/tb-borrow-applyfor/queryStoragers',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 获取config配置
export function getConfigInfo(params){
	return request({
		url:'/getJsApi',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 添加领用记录
export function addApplyRecord(data){
	return request({
		url:'/tb-borrow-applyfor/addApplyfor',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 查询入库气瓶详细信息
export function queryBottleDetail(params){
	return request({
		url:'/tb-bottle-info/queryBottleDetail',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 提交审核
export function applyAudits(params){
	return request({
		url:'/tb-borrow-applyfor/borrowAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//查询领用提交审核记录
export function queryHistoryRecord(params){
	return request({
		url:'/tb-borrow-applyfor/queryAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

// 归还
// 历史记录
export function queryHistoryRecordByReturn(params){
	return request({
		url:'/tb-return-applyfor/queryAudit',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 添加归还记录
export function addReturnRecord(data){
	return request({
		url:'/tb-return-applyfor/addApplyfor',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}

// 归还历史记录
export function queryReturnHistory(params){
	return request({
		url:'/tb-return-applyfor/queryReturnHistory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 归还历史记录详情
export function queryReturnDetail(params){
	return request({
		url:'/tb-return-applyfor/queryReturnDetail',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//根据条码查询要归还的气瓶
export function queryReturnBottle(params){
	return request({
		url:'/tb-return-applyfor/queryBottle',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//根据二维码查询要归还的气瓶
export function queryReturnBottleByQrcode(params){
	return request({
		url:'/tb-return-applyfor/queryBottleByQrcode',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

export function queryBorrowOverdue(params){
	return request({
		url:'/stock/queryBorrowOverdue',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//#endregion 气瓶模块

//#region 气瓶入库
// 获取wx.config配置参数
export function getJsApi(params){
	return request({
		url:'/getJsApi',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 查询所有登记单位/厂家
export function bottleInfoQueryAll(params){
	return request({
		url:'/tb-bottle-info/queryAll',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 查询气体类型
export function queryGasType(params){
	return request({
		url:'/tb-bottle-info/queryGasType',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 查询气瓶状态
export function queryBottleStatus(params){
	return request({
		url:'/tb-bottle-info/queryBottleStatus',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 查询所气瓶入库审核者信息
export function queryIncomingAuditor(params){
	return request({
		url:'/tb-incoming-applyfor/queryIncomingAuditor',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 查询气瓶信息
export function queryByQrcode(params){
	return request({
		url:'/tb-bottle-info/queryByQrcode',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

export function parseQrcode(params){
	return request({
		url:'/tb-bottle-info/parseQrcode',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

// 添加气瓶入库记录
export function addApplyfor(data){
	return request({
		url:'/tb-incoming-applyfor/addApplyfor',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 添加气瓶入库历史记录
export function queryIncomingHistory(params){
	return request({
		url:'/tb-incoming-applyfor/queryIncomingHistory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//endregion  气瓶入库

//#region 气瓶汇总统计查询
export function stockcollect(params){
	return request({
		url:'/stock/stockcollect',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//查询检测时间超期预警的气瓶列表
export function queryEarlyWarn(params){
	return request({
		url:'stock/queryEarlyWarn',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//处理检测时间超期预警的气瓶
export function handleWarn(data){
	return request({
		url:'/stock/handleWarn',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}

// 气瓶所有登记单位
export function ownerDeptList(params){
	return request({
		url:'tb-bottle-info/queryAll',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

// 气瓶状态
export function queryBottleStatusList(params){
	return request({
		url:'tb-bottle-info/queryBottleStatus',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

// 汇总查询分页
export function stockQueryList(params, data){
	return request({
		url:'stock/stockquery',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data: data,
		params
	})
}



export function bottleStockflow(params, data){
	return request({
		url:'stock/bottlestockflow',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data: data,
		params
	})
}
//#endregoin 气瓶汇总统计查询

//#regoin 气瓶出库
// 添加气瓶出库记录
export function outcomingAddApplyfor(data){
	return request({
		url:'/tb-outcoming-applyfor/addApplyfor',
		method:'post',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		data
	})
}
// 查询当前要出库的气瓶信息
export function queryBottle(params){
	return request({
		url:'/tb-outcoming-applyfor/queryBottle',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

export function queryOutcomingBottleByQrcode(params){
	return request({
		url:'/tb-outcoming-applyfor/queryBottleByQrcode',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

// 气瓶出库历史记录
export function queryOutcomingHistory(params){
	return request({
		url:'/tb-outcoming-applyfor/queryOutcomingHistory',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
// 气瓶出库历史记录详情
export function queryOutcomingDetail(params){
	return request({
		url:'/tb-outcoming-applyfor/queryOutcomingDetail',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}

//未归还的领用记录
export function queryNoReturnBottleList(params){
	return request({
		url:'/tb-borrow-applyfor/queryNoReturnBottleList',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}
//#endregoin 气瓶出库

export function checkAuthority(params){
	return request({
		url:'/checkAuthority',
		method:'get',
		headers:{
			token:localStorage.getItem('token')||'',
		},
		params
	})
}